<div class="property-popup" [class.layout-grid]="layout === 'grid'">
    <div class="row">
        <div class="col-image">
            <div class="property-image">
                <img [src]="ImageFileUrl" alt="Property Image" loading="lazy" (error)="onImageError($event)" />
            </div>
        </div>
        <div class="col-details">
            <div class="header">
                <span class="price">{{ getPropertyPriceDisplay(advert?.propertyInfoPrice) }}</span>
                <div class="status-icons" *ngIf="icons.length > 0">
                    <div *ngFor="let icon of icons" class="icon-wrapper" [matTooltip]="icon.text" matTooltipClass="small-tooltip">
                        <img [src]="icon.iconPath" [alt]="icon.text" class="status-icon" />
                    </div>
                </div>
            </div>
            <div class="details">
                <div class="address">{{ advert?.propertyInfoSizeTypeLocation }}</div>
                <div class="highest-best" *ngIf="layout !== 'grid'; else gridHighestBest">
                    <span class="label">Highest Best:</span>
                    <span class="value">{{ advert?.propertyInfoShortDescription }}</span>
                </div>
                <ng-template #gridHighestBest>
                    <div class="highest-best-grid">
                        <span class="label">Highest</span>
                        <span class="label">Best:<span class="value">{{ advert?.propertyInfoShortDescription }}</span></span>
                    </div>
                </ng-template>
            </div>
            <div class="cta">
                <button *ngIf="layout === 'grid'; else popupCta" class="cta-button-outline" (click)="openPropertyDetailsPopup()">
                    Download FREE info
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <ng-template #popupCta>
                    <button class="cta-button" (click)="openPropertyDetailsPopup()">
                        View property options
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </ng-template>
            </div>
        </div>
    </div>
</div>
